import React, { useState } from "react";


export default function AgentFiltter({ onFilter }) {
    const [filters, setFilters] = useState({
        name: "",
        email: "",
        mobile: "",
        status: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
            setFilters((prev) => ({
            ...prev,
            [name]: value,
            }));

    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onFilter(filters);
    };

    return (
        <div className="filtercont">
            <div className="row">
                <div className="col-lg-10">
                    <div className="row">
                        <div className="col-12 col-sm-3 pr-lg-0">
                            <label>Filter By Name</label>
                            <input type="text" name="name"
                                value={filters.name}
                                onChange={handleChange}
                                className="form-control" />
                        </div>
                        <div className="col-12 col-sm-3 pr-lg-0">
                            <label>Email ID</label>
                            <input type="email" value={filters.email}
                                onChange={handleChange}
                                name="email" className="form-control" />
                        </div>
                        <div className="col-12 col-sm-3 pr-lg-0">
                            <label>Mobile</label>
                            <input type="text" name="mobile"
                                value={filters.mobile}
                                onChange={handleChange}
                                className="form-control" />
                        </div>
                        <div className="col-12 col-sm-3 pr-lg-0">
                            <label>Status</label>
                            <select name="status"
                                    className="form-control"
                                    value={filters.status}
                                    onChange={handleChange}
                            >
                                <option>All</option>
                                <option value={'Active'}>Active</option>
                                <option value={'Deactive'}>Deactive</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div className="col-lg-2">
                    <label>&nbsp;</label>
                    <a className="btn btn-default submit sitebtn" onClick={ handleSubmit}>
                        Submit
                    </a>
                </div>
            </div>
        </div>
    )
}